import { render, staticRenderFns } from "./TripLayout.vue?vue&type=template&id=63e97666&scoped=true&lang=pug"
import script from "./TripLayout.vue?vue&type=script&lang=js"
export * from "./TripLayout.vue?vue&type=script&lang=js"
import style0 from "./TripLayout.vue?vue&type=style&index=0&id=63e97666&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e97666",
  null
  
)

export default component.exports